var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-cover",
      class: {
        "v-cover--overlay": _vm.overlay,
        "v-cover--contain": _vm.contain,
        "v-cover--dark": _vm.dark,
      },
    },
    [
      _vm.image
        ? _c("div", {
            ref: "image",
            staticClass: "v-cover__image",
            style: { backgroundImage: `url('${_vm.image}')` },
          })
        : _vm._e(),
      _c("p", { staticClass: "wrapper v-cover__wrapper v-cover__title" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _vm._l(_vm.description, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "wrapper v-cover__wrapper v-cover__description",
          },
          [_vm._v(" " + _vm._s(item?.description) + " ")]
        )
      }),
      _vm.cta
        ? _c(
            "div",
            { staticClass: "v-cover__content wrapper" },
            [
              _c(
                "v-button",
                {
                  directives: [
                    {
                      name: "touch",
                      rawName: "v-touch:tap",
                      value: () => this.start(),
                      expression: "() => this.start()",
                      arg: "tap",
                    },
                  ],
                  staticClass: "v-cover__button",
                },
                [
                  _c("p", { staticClass: "v-cover__button-text" }, [
                    _vm._v(_vm._s(_vm.cta)),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }